module.exports = __webpack_public_path__ + "static/media/image_rural_m.fd7ddf70.png";